import { appConfig } from 'config/customization';
import * as FontSizes from 'constants/fonts';

const Colors = appConfig.colors;
const SassColors = appConfig.sassColors;

export const energyUITheme = {
  UTAlert: {
    error: {
      backgroundColor: appConfig.colors.notificationError
    },
    info: {
      backgroundColor: appConfig.colors.notificationInfo
    },
    success: {
      backgroundColor: appConfig.colors.notificationSuccess
    }
  },
  UTTextInput: {
    underline: {
      hover: { borderBottom: `1px solid ${Colors.gray}` },
      disabled: { borderBottom: `1px solid ${Colors.gray}` },
      unfocused: { borderBottom: `1px solid ${Colors.gray}` },
      focused: { borderBottom: `2px solid ${Colors.primary}` },
      base: { borderBottom: `2px solid ${Colors.primary}` }
    },
    formLabel: {
      color: Colors.gray,
      errorColor: Colors.gray,
      focusedColor: Colors.primary,
      focusedErrorColor: Colors.error
    },
    container: {
      padding: 4
    },
    tooltipIcon: {
      color: appConfig.colors.primary
    }
  },
  UTLabel: {
    base: {
      fontSize: FontSizes.medium
    },
    primary: {
      color: Colors.primary
    },
    secondary: {
      color: Colors.blue
    },
    alternative: {
      color: Colors.red
    },
    gray: {
      color: Colors.lightGray
    },
    darkGray: {
      color: Colors.gray
    },
    error: {
      color: Colors.error
    }
  },
  UTButton: {
    base: {
      backgroundColor: Colors.primaryButton,
      borderRadius: appConfig.buttonRadius,
      fontSize: FontSizes.small,
      color: Colors.white,
      hover: {
        backgroundColor: Colors.primaryButtonHover
      }
    },
    baseText: {
      color: Colors.primaryButton,
      fontSize: FontSizes.small,
      hover: {
        backgroundColor: Colors.primaryTextButtonHover
      }
    },
    baseOutlined: {
      borderColor: Colors.primaryButton,
      borderRadius: appConfig.buttonRadius,
      color: Colors.primaryButton,
      fontSize: FontSizes.small,
      hover: {
        backgroundColor: Colors.primaryTextButtonHover
      }
    },
    secondary: {
      backgroundColor: Colors.secondaryButton,
      color: Colors.white,
      hover: {
        backgroundColor: Colors.secondaryButtonHover
      }
    },
    secondaryText: {
      color: Colors.secondaryButton,
      hover: {
        backgroundColor: Colors.secondaryTextButtonHover
      }
    },
    secondaryOutlined: {
      borderColor: Colors.secondaryButton,
      color: Colors.secondaryButton,
      hover: {
        backgroundColor: Colors.secondaryTextButtonHover
      }
    },
    alternative: {
      backgroundColor: Colors.alternativeButton,
      color: Colors.white,
      hover: {
        backgroundColor: Colors.alternativeButton
      }
    },
    alternativeText: {
      color: Colors.alternativeButton,
      hover: {
        backgroundColor: Colors.alternativeButton
      }
    },
    alternativeOutlined: {
      borderColor: Colors.alternativeButton,
      color: Colors.alternativeButton,
      hover: {
        backgroundColor: Colors.alternativeButton
      }
    },
    gray: {
      backgroundColor: Colors.gray,
      color: Colors.white
    },
    grayText: {
      color: Colors.gray
    },
    grayOutlined: {
      borderColor: Colors.gray,
      color: Colors.gray
    },
    disabled: {
      backgroundColor: Colors.disabledButton,
      color: Colors.white
    },
    disabledText: {
      color: Colors.disabledButton
    },
    disabledOutlined: {
      borderColor: Colors.disabledButton,
      color: Colors.disabledButton
    },
    loading: {
      color: Colors.primaryButton
    }
  },
  UTPhoneInput: {
    areaCodeIcon: {
      fill: appConfig.colors.primary
    }
  },
  UTAttachment: {
    container: {
      border: `1px dashed ${Colors.attachmentBorder}`
    },
    fileInputLabel: {
      color: Colors.black
    }
  },
  UTRatingStar: {
    label: {
      color: Colors.gray
    }
  },
  Loading: {
    base: {
      color: SassColors.loadingBase,
      size: 85,
      thickness: 1.5
    }
  },
  Fonts: {
    fontFamily: appConfig.fontFamily,
    xxsmall: FontSizes.xxsmall,
    xsmall: FontSizes.xsmall,
    small: FontSizes.small,
    medium: FontSizes.medium,
    large: FontSizes.large,
    xlarge: FontSizes.big,
    xxlarge: FontSizes.title
  },
  Media: {
    tabletMobile: '@media only screen and (max-width: 1024px)'
  },
  UTCard: {
    flat: {
      backgroundColor: Colors.cardFlat
    }
  }
};
